const env = require('./env');

export function getEnv() {
  // 一般情况下，gitlab-ci中会设置CURRENT_CLIENT_ENV，如有环境问题处理build参数即可，以下的if只作为兼容语句保留
  let current_env = process.env.CURRENT_ENV || process.env.CURRENT_CLIENT_ENV;
  try {
    if (process.env.MODE_CLIENT_ENV === 'CLIENT' && location && location.host) {
      if (location.host === 'mastergo.com' || location.host === 'mgdesign.com') {
        current_env = 'prod';
      } else if (location.host === 'dev.mastergo.com' || location.host === 'dev.mgdesign.com') {
        current_env = 'dev';
      } else if (location.host === 'pre.mastergo.com' || location.host === 'pre.mgdesign.com') {
        current_env = 'pre';
      } else if (location.host === 'ceshi.mastergo.com' || location.host === 'ceshi.mgdesign.com') {
        current_env = 'native';
      }
      else if (location.host === 'pts.mastergo.com' || location.host === 'pts.mgdesign.com') {
        current_env = 'pts';
      }else if (process.env.CURRENT_CLIENT_ENV) {
        current_env = process.env.CURRENT_CLIENT_ENV;
      }
    }
  } catch (e) {
    console.log('服务端打包');
  }

  return current_env;
}
export const setting_obj = {
  ...env[getEnv()],
  router_base: '/community',
  publicPath: process.env.CDN_PATH ? `${process.env.CDN_PATH}/client` : '',
  colorPattern: 'light', // 亮暗色，亮色 light,暗色 dark  默认主题色调
  log_url: '',
  srcDir: process.env.CDN_PATH || '',
  // ceshiPath: 'https://static.mastergo.com/universe/client',
};
